import { AfterViewInit, Component, ElementRef, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import _ from 'lodash';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalService, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Subject } from 'rxjs';
import { MODAL_HEIGHT_LEVEL_3, MODAL_WIDTH_LEVEL_3, MODAL_TOP_LEVEL_3, MODAL_WIDTH_LEVEL_4, MODAL_TOP_LEVEL_4, MODAL_HEIGHT_LEVEL_4 } from 'src/app/core/constants/components';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { FinalProductService } from 'src/app/private/services/final-product.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { ArticleBatchDto } from 'src/app/shared/dto/article-batch.dto';
import { FinalProductDto } from 'src/app/shared/dto/final-product.dto';
import { PackagingDto } from 'src/app/shared/dto/packaging.dto';
import { ArticleSearchResponseDto } from 'src/app/shared/dto/pagination/articles-search-response.dto';
import { RawMaterialDto } from 'src/app/shared/dto/rawMaterial.dto';
import { SourceEnum } from 'src/app/shared/enums/source.enum';
import { ModalSearchArticlesComponent } from '../modal-search-articles/modal-search-articles.component';
import { ArticlesService } from 'src/app/private/services/articles.service';
import { ModalRawMaterialEditionComponent } from '../modal-raw-material-edition/modal-raw-material-edition.component';

//TODO: refactor mixing with modal raw materials

@Component({
    selector: 'app-modal-raw-materials-final-product-or-packaging',
    standalone: true,
    imports: [
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzModalTitleDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        ReactiveFormsModule,
        FormsModule,
        NzModalFooterDirective,
        NzMessageModule,
        NzSelectModule,
        NzIconModule,
        NzInputDirective,
        NzInputGroupComponent,
        NzInputGroupWhitSuffixOrPrefixDirective,
        NzEmptyModule,
        NzToolTipModule,
        LoaderComponent,
        NzButtonModule
    ],
    templateUrl: './modal-raw-materials-final-product-or-packaging.component.html',
    styleUrl: './modal-raw-materials-final-product-or-packaging.component.scss'
})
export class ModalRawMaterialsFinalProductOrPackagingComponent implements OnInit, AfterViewInit, OnDestroy {
    @Output() emitService = new EventEmitter();
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;
    @ViewChild('myInput') myInputRef!: ElementRef<HTMLInputElement>;

    isLoading: boolean = true;
    isSaving: boolean = false;
    rawMaterials: RawMaterialDto[] = [];
    tableHeight!: number;
    textAreaBatchSearchValue: string = '';

    private finalProduct: FinalProductDto = new FinalProductDto();
    private packaging: PackagingDto = new PackagingDto();
    private source: string = '';
    private finalProductsToAddRawMaterialsIds: number[] = [];
    private packagingsToAddRawMaterialsIds: number[] = [];
    private orderProcessId: number = 0;
    private articleBatchNumberSearchValue: string = '';

    readonly data = inject(NZ_MODAL_DATA);
    private readonly finalProductsService = inject(FinalProductService);
    private readonly articleService = inject(ArticlesService);
    private readonly message = inject(NzMessageService);
    private readonly unsubscribe$ = new Subject();
    private readonly modalRef = inject(NzModalRef);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly modalService = inject(NzModalService);

    /**
     *
     */
    constructor() {
        this.modalRef.afterOpen.subscribe(() => {
            setTimeout(() => this.myInputRef.nativeElement.focus(), 0);
        });
    }

    async ngOnInit(): Promise<void> {
        this.orderProcessId = this.data?.orderProcessId;
        this.source = this.data?.source ?? '';
        this.finalProduct = this.data?.finalProduct;
        this.packaging = this.data?.packaging;

        if (this.source === SourceEnum.FINAL_PRODUCT) {
            this.finalProduct = this.data?.finalProduct;
            this.rawMaterials = await this.finalProductsService.getRawMaterialsByFinalProduct(this.data?.finalProduct.id);
        } else if (this.source === SourceEnum.FINAL_PRODUCT_MULTIPLE) {
            this.finalProduct = this.data?.finalProduct;
            this.finalProductsToAddRawMaterialsIds = this.data?.finalProductsToAddRawMaterialsIds;
        } else if (this.source === SourceEnum.PACKAGING) {
            this.rawMaterials = await this.finalProductsService.getRawMaterialsByFinalProductAndPackaging(this.finalProduct.id, this.packaging.id);
        } else if (this.source === SourceEnum.PACKAGING_MULTIPLE) {
            this.packagingsToAddRawMaterialsIds = this.data?.packagingsToAddRawMaterialsIds;
        }

        if (!this.rawMaterials) {
            this.isLoading = false;
            this.message.warning('No se encontraron materias primas');
            return;
        }

        this.isLoading = false;
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next({});
        this.unsubscribe$.complete();
    }

    openSearchArticlesModal(){
        const modal = this.modalService.create({
            nzContent: ModalSearchArticlesComponent,
            nzStyle: {
                width: (this.source === SourceEnum.PACKAGING_MULTIPLE || this.source === SourceEnum.PACKAGING) ? MODAL_WIDTH_LEVEL_4 : MODAL_WIDTH_LEVEL_3,
                top: (this.source === SourceEnum.PACKAGING_MULTIPLE || this.source === SourceEnum.PACKAGING) ? MODAL_TOP_LEVEL_4 : MODAL_TOP_LEVEL_3
            },
            nzBodyStyle: {
                height: (this.source === SourceEnum.PACKAGING_MULTIPLE || this.source === SourceEnum.PACKAGING) ? MODAL_HEIGHT_LEVEL_4 : MODAL_HEIGHT_LEVEL_3
            },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Buscar materias primas`,
                articlesToRemove: this.rawMaterials.flatMap(plainRawMaterial => {
                    const articleSearchResponseDto = new ArticleSearchResponseDto();
                    articleSearchResponseDto.articleId = plainRawMaterial.article?.id!;
                    articleSearchResponseDto.articleBatchId = plainRawMaterial.articleBatch?.id ?? undefined;
                    articleSearchResponseDto.packagingId = plainRawMaterial.usedPackaging?.id ?? undefined;
                    return articleSearchResponseDto;
                })
            }
        });

        modal.componentInstance?.emitService.subscribe(async (rawMaterialSelected:ArticleSearchResponseDto) => {
            console.log(rawMaterialSelected);

            const newRawMaterial = {
                    articleId: rawMaterialSelected.articleId ?? undefined,
                    article: rawMaterialSelected.article ?? undefined,
                    articleBatchId: rawMaterialSelected.articleBatchId ?? undefined,
                    articleBatch: rawMaterialSelected.articleBatch ?? undefined,
                    usedPackagingId: rawMaterialSelected.packagingId ?? undefined,
                    usedPackaging: rawMaterialSelected.packaging ?? undefined,
                    createdById: this.userLoggedService.userLogged.id,
                    rawQuantity: rawMaterialSelected.packaging?.quantity ?? 0
                } as RawMaterialDto;

            await this.editRawMaterial(newRawMaterial);

            modal.close();
        });
    }

    deleteRawMaterial(idx: number) {
        this.rawMaterials.splice(idx, 1);
        this.rawMaterials = [...this.rawMaterials];
    }

    canEdit(createdById: number | undefined){
        if (createdById) {
            return createdById != this.userLoggedService.userLogged.id;
        }

        return true;
    }

    canDelete(createdById: number | undefined){
        if (createdById) {
            return createdById != this.userLoggedService.userLogged.id;
        }

        return true;
    }

    async onArticleBatchSearch(): Promise<void> {
        this.articleBatchNumberSearchValue = this.textAreaBatchSearchValue && this.textAreaBatchSearchValue != '' ? this.textAreaBatchSearchValue : this.articleBatchNumberSearchValue;

        if (this.textAreaBatchSearchValue.match(/\n/)) {
            this.isLoading = true;

            this.textAreaBatchSearchValue = '';

            const searchTerm = this.articleBatchNumberSearchValue.trim();

            const foundArticleBatch: ArticleBatchDto = await this.articleService.getArticleBatchByBatchNumber(searchTerm);

            if (!foundArticleBatch) {
                this.message.error(`No se ha podido encontrar un lote con el número de lote o empaquetado con el número de lote ${searchTerm}`);
            } else {
                let existingRawMaterial: RawMaterialDto | undefined = undefined;

                if (foundArticleBatch.packagings && foundArticleBatch.packagings.length > 0){
                    existingRawMaterial = this.rawMaterials.find(rm => rm.usedPackagingId && rm.usedPackagingId > 0 && rm.usedPackagingId === foundArticleBatch.packagings![0].id);

                    if (existingRawMaterial) {
                        this.message.warning(`Ya existe en la lista el empaquetado ${existingRawMaterial.usedPackaging?.batchNumber} con el lote ${existingRawMaterial.articleBatch?.batchNumber}`);

                        this.articleBatchNumberSearchValue = '';

                        this.isLoading = false;

                        return;
                    }
                }

                const newRawMaterial = {
                    articleId: foundArticleBatch.articleId ?? undefined,
                    article: foundArticleBatch.article ?? undefined,
                    articleBatchId: foundArticleBatch.id ?? undefined,
                    articleBatch: foundArticleBatch ?? undefined,
                    usedPackagingId: foundArticleBatch.packagings && foundArticleBatch.packagings.length > 0 ? foundArticleBatch.packagings[0].id : undefined,
                    createdById: this.userLoggedService.userLogged.id,
                    rawQuantity: foundArticleBatch.packagings && foundArticleBatch.packagings.length > 0 ? foundArticleBatch.packagings[0].quantity : foundArticleBatch.quantity
                } as RawMaterialDto;

                await this.editRawMaterial(newRawMaterial);
            }

            this.articleBatchNumberSearchValue = '';

            this.isLoading = false;
        }
    }

    async editRawMaterial(rawMaterial: RawMaterialDto) {
        const modal = this.modalService.create({
            nzContent: ModalRawMaterialEditionComponent,
            nzStyle: { width: '30%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Editar materia prima ${rawMaterial.usedPackaging?.batchNumber}`,
                rawMaterial: rawMaterial
            }
        });

        modal.componentInstance?.emitService.subscribe(async (edittedRawMaterial: RawMaterialDto) => {
            if (!edittedRawMaterial) {
                this.rawMaterials = _.cloneDeep(this.rawMaterials.filter(rm => rm.id != rawMaterial.id));
            } else {
                const rawMaterialToUpdateIndex: number = this.rawMaterials.findIndex(rw => rw.id === edittedRawMaterial.id);

                if (rawMaterialToUpdateIndex > 0) {
                    this.rawMaterials[rawMaterialToUpdateIndex].rawQuantity = edittedRawMaterial.rawQuantity;
                } else {
                    this.rawMaterials.push(edittedRawMaterial);
                }

                this.rawMaterials = _.cloneDeep(this.rawMaterials);
            }

            modal.close();
        });
    }

    async handleSave(): Promise<void> {
        try {
            this.isSaving = true;
            let updatedFinalProducts: FinalProductDto[] = [];

            if (this.source === SourceEnum.PACKAGING_MULTIPLE) {
                updatedFinalProducts = await this.finalProductsService.addRawMaterialsToFinalProductsOrPackagings(this.rawMaterials, [this.finalProduct.id!], this.source, this.packagingsToAddRawMaterialsIds, this.orderProcessId);
            } else if (this.source === SourceEnum.FINAL_PRODUCT_MULTIPLE){
                updatedFinalProducts = await this.finalProductsService.addRawMaterialsToFinalProductsOrPackagings(this.rawMaterials , this.finalProductsToAddRawMaterialsIds, this.source, undefined, this.orderProcessId);
            } else if(this.source === SourceEnum.FINAL_PRODUCT){
                updatedFinalProducts = await this.finalProductsService.addRawMaterialsToFinalProductsOrPackagings(this.rawMaterials, [this.finalProduct.id!], this.source, undefined, this.orderProcessId);
            } else if (this.source === SourceEnum.PACKAGING) {
                updatedFinalProducts = await this.finalProductsService.addRawMaterialsToFinalProductsOrPackagings(this.rawMaterials, [this.finalProduct.id!], this.source, [this.packaging.id!], this.orderProcessId);
            }

            this.emitService.emit(updatedFinalProducts);

            this.isSaving = false;
            this.message.success('Materias primas añadidas correctamente');

            this.modalRef.close();
        } catch (error: any) {
            this.isSaving = false;
            if(this.source === SourceEnum.FINAL_PRODUCT_MULTIPLE){
                this.message.error('No se han podido añadir las materias prima a los productos finales');
            } else if (this.source === SourceEnum.PACKAGING_MULTIPLE) {
                this.message.error('No se ha podido añadir las materias prima a los formatos');
            } else if (this.source === SourceEnum.FINAL_PRODUCT) {
                this.message.error('No se ha podido añadir la materia prima al producto final');
            } else if (this.source === SourceEnum.PACKAGING) {
                this.message.error('No se ha podido añadir la materia prima al formato');
            }
        }
    }

    handleCancel() {
        this.modalRef.close();
    }

    validateRawMaterials(rawMaterialsToLink: RawMaterialDto[]): boolean {
        let isValid = true;
        for(const rawMaterial of rawMaterialsToLink){
            if(!rawMaterial.articleId){
                this.message.error('El artículo es obligatorio');
                isValid = false;
            }

            if(rawMaterial.article!.useBatches && !rawMaterial.articleBatchId){
                this.message.error(`El lote es obligatorio para el artículo ${rawMaterial.article?.name}`);
                isValid = false;
            }

            if(rawMaterial.article?.usePackagings && !rawMaterial.usedPackagingId){
                this.message.error(`El formato es obligatorio para el artículo ${rawMaterial.article?.name}`);
                isValid = false;
            }

            if(rawMaterial.rawQuantity <= 0){
                this.message.error(`La cantidad es obligatoria para el artículo ${rawMaterial.article?.name}`);
                isValid = false;
            }
        }

        return isValid;
    }
}
